var map = {
	"./music-instructions.json": 5185,
	"./music-library-intro2024.json": 5186,
	"./music-library-launch2024.json": 5187,
	"./music-progression.json": 5188,
	"./startSourcesAdvanced.json": 5189,
	"./startSourcesSimple.json": 5190,
	"./startSourcesSimple2.json": 5191,
	"./startSourcesTracks.json": 5192
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4791;